import { render, staticRenderFns } from "./switch-org.vue?vue&type=template&id=b5d8802c&"
import script from "./switch-org.vue?vue&type=script&lang=js&"
export * from "./switch-org.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports